import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
// @ts-ignore
import { selectCurrentSeasonId } from 'services/currentSeasonId/selectors';
// @ts-ignore
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';
import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import {
    selectFertilizerEventsFilterType,
    selectFertilizerEventsSearchQueryString
} from './selectors';
import {
    FERTILIZER_DATE_RANGE_FILTER_TYPE,
    FERTILIZER_ENTITIES_FILTER_TYPE,
    FERTILIZER_INNER_ENTITIES_FILTER_TYPE,
    FERTILIZER_PRODUCT_FILTER_TYPE
} from './constants';

const selectFertilizerEventsFilter = createDeepEqualSelector(
    [
        selectFertilizerEventsFilterType,
        selectFirstDate,
        selectLastDate,
        selectFertilizerEventsSearchQueryString
    ],
    (
        filterType,
        firstDateState: string,
        lastDateState: string,
        searchFilters
    ) => {
        const {
            fertilizerProductId,
            startDate,
            endDate,
            fertilizerEntityId,
            fertilizerInnerEntityId
        } = searchFilters;
        let filters: Array<Record<string, any>> = [];

        switch (filterType) {
            case FERTILIZER_PRODUCT_FILTER_TYPE:
                filters.push({
                    'fertilizerEvent.fertilizerProducts.id': fertilizerProductId
                });
                break;
            case FERTILIZER_DATE_RANGE_FILTER_TYPE:
                filters = [
                    { startDate: { $gte: startDate } },
                    { startDate: { $lte: endDate } }
                ];
                break;
            case FERTILIZER_ENTITIES_FILTER_TYPE:
                filters.push({
                    entityId: fertilizerEntityId
                });
                break;
            case FERTILIZER_INNER_ENTITIES_FILTER_TYPE:
                filters.push({
                    'fertilizerEvent.fertilizerEntities.id':
                        fertilizerInnerEntityId
                });
                break;
            default:
                filters = [
                    { startDate: { $gte: firstDateState } },
                    { startDate: { $lte: lastDateState } }
                ];
                break;
        }

        return filters;
    }
);

const selectLoadFertilizerEventsParams = createDeepEqualSelector(
    [
        selectCurrentOrganizationId,
        selectCurrentSeasonId,
        selectCurrentEntityId,
        selectFertilizerEventsFilter
    ],
    (
        currentOrganizationIdState: string | undefined,
        currentSeasonIdState: number | undefined,
        currentEntityIdState: number | undefined,
        fertilizerFilter
    ) => ({
        organizationId: currentOrganizationIdState,
        filter: {
            eager: '[jobs.assignedUsers, fertilizerEvent.[fertilizerEntities, fertilizerProducts]]',
            require: {
                $and: [
                    {
                        'schema.eventTypeId': 'FERTILIZER',
                        deletedAt: { $exists: false },
                        ...(currentSeasonIdState
                            ? { 'entity.seasonId': currentSeasonIdState }
                            : {}),
                        $and: [
                            ...fertilizerFilter,
                            ...(currentEntityIdState
                                ? [
                                      {
                                          $or: [
                                              {
                                                  'entity.path': {
                                                      $or: [
                                                          {
                                                              $like: `/${currentEntityIdState}/%`
                                                          },
                                                          {
                                                              $equals: `/${currentEntityIdState}`
                                                          }
                                                      ]
                                                  }
                                              },
                                              {
                                                  entityId: currentEntityIdState
                                              }
                                          ]
                                      }
                                  ]
                                : [])
                        ]
                    }
                ]
            },
            order: 'jobs.jobType asc'
        }
    })
);

export { selectLoadFertilizerEventsParams, selectFertilizerEventsFilter };
